import { useState, useEffect } from 'react';
import { FaWhatsapp, FaArrowUp } from 'react-icons/fa';
import API from '../api/axios';

const FloatingButtons = () => {
  const [showTop, setShowTop] = useState(false);
  const [whatsapp, setWhatsapp] = useState('');

  useEffect(() => {
    API.get('/settings/public').then(r => setWhatsapp(r.data?.social?.whatsapp || '')).catch(() => {});
    const handleScroll = () => setShowTop(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="floating-buttons">
      {whatsapp && (
        <a href={whatsapp.startsWith('http') ? whatsapp : `https://wa.me/${whatsapp.replace(/\D/g, '')}`}
          target="_blank" rel="noreferrer" className="float-btn whatsapp" title="Chat on WhatsApp">
          <FaWhatsapp />
        </a>
      )}
      {showTop && (
        <button onClick={scrollToTop} className="float-btn back-to-top" title="Back to Top">
          <FaArrowUp />
        </button>
      )}
    </div>
  );
};

export default FloatingButtons;
